"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedSecuritySettingsService = void 0;
/**
 * @alpha
 */
var DecoratedSecuritySettingsService = /** @class */ (function () {
    function DecoratedSecuritySettingsService(decorated) {
        this.decorated = decorated;
        this.scope = this.decorated.scope;
    }
    DecoratedSecuritySettingsService.prototype.isUrlValid = function (url, context) {
        return this.decorated.isUrlValid(url, context);
    };
    DecoratedSecuritySettingsService.prototype.isDashboardPluginUrlValid = function (url, workspace) {
        return this.decorated.isDashboardPluginUrlValid(url, workspace);
    };
    return DecoratedSecuritySettingsService;
}());
exports.DecoratedSecuritySettingsService = DecoratedSecuritySettingsService;
//# sourceMappingURL=securitySettings.js.map